import { ProductExperiencesProvider } from './state/ProductExperiencesProvider';
import { TourProvider } from './tours/TourProvider';

// Mounted once around the app (App.tsx): the per-user state, then the tours
// that read and record it. The bell and /whats-new read the same state.
export const ProductUpdatesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <ProductExperiencesProvider>
    <TourProvider>{children}</TourProvider>
  </ProductExperiencesProvider>
);
